import { Box, MenuItem, Pagination, Select } from '@mui/material';
import type { SelectChangeEvent } from '@mui/material';
import Typography from '@mui/material/Typography';

export type DoorVisitTableFooterProps = {
  total: number;
  page: number;
  rowsPerPage: number;
  rowsPerPageOptions?: number[];
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
};

// Figma's footer (node 52:2624) uses a numbered <Pagination> with first/last
// skip buttons rather than MUI's TablePagination (prev/next only) — this
// component converts between 0-based page state and Pagination's 1-based API.
export const DoorVisitTableFooter = ({
  total,
  page,
  rowsPerPage,
  rowsPerPageOptions = [12, 25, 50],
  onPageChange,
  onRowsPerPageChange,
}: DoorVisitTableFooterProps) => {
  const pageCount = Math.max(1, Math.ceil(total / rowsPerPage));

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1,
        minHeight: 52,
        px: 2,
        py: 0.5,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="caption" color="text.secondary">
          Rows per page:
        </Typography>
        <Select
          variant="standard"
          disableUnderline
          size="small"
          value={rowsPerPage}
          onChange={(event: SelectChangeEvent<number>) => onRowsPerPageChange(Number(event.target.value))}
          inputProps={{ 'aria-label': 'Rows per page' }}
        >
          {rowsPerPageOptions.map(option => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <Pagination
        count={pageCount}
        page={page + 1}
        onChange={(_event, newPage) => onPageChange(newPage - 1)}
        showFirstButton
        showLastButton
        shape="rounded"
        size="small"
      />
    </Box>
  );
};
